import { TENANT_SETTING_KEYS } from '@services/fmdc';

// What the settings form sends: only the keys the admin changed. A key cleared to empty is sent
// as `null`, which the API documents as "reset to default"; a key never touched is absent, so the
// server never sees a value it did not already hold.

const normalize = (value) => (value === undefined || value === '' ? null : value);

export const settingsDiff = (original, draft) => {
  const patch = {};
  TENANT_SETTING_KEYS.forEach(({ key }) => {
    const before = normalize(original?.[key]);
    const after = normalize(draft?.[key]);
    if (before === after) return;
    patch[key] = after;
  });
  return patch;
};

// The draft a form opens on: the server's settings, with every known key present (null when the
// server holds no value, which the form shows as "default").
export const settingsDraftFrom = (settings) =>
  Object.fromEntries(TENANT_SETTING_KEYS.map(({ key }) => [key, normalize(settings?.[key])]));

export const isDefaultSetting = (settings, key) => normalize(settings?.[key]) === null;
